var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2 16C3.2 8.93 8.93 3.2 16 3.2c4.027 0 7.566 1.862 9.892 4.79l-2.687-.009a1.6 1.6 0 10-.01 3.2l5.509.016c.061.004.123.004.185 0l.706.003A1.6 1.6 0 0031.2 9.6V3.2a1.6 1.6 0 10-3.2 0v2.32C25.1 2.144 20.837 0 16 0 7.163 0 0 7.163 0 16a1.6 1.6 0 103.2 0zM28.8 16c0 7.07-5.73 12.8-12.8 12.8-4.027 0-7.566-1.862-9.892-4.79l2.687.009a1.6 1.6 0 00.01-3.2l-5.509-.016a1.626 1.626 0 00-.185 0l-.706-.003A1.6 1.6 0 00.8 22.4v6.4a1.6 1.6 0 103.2 0v-2.32C6.9 29.856 11.163 32 16 32c8.836 0 16-7.164 16-16a1.6 1.6 0 10-3.2 0z"
  })))));
}

export default SvgIconRefresh;